import React from 'react'

const Clarity = () => {
  return (
    <section>
          <div className="w3-padding-64 w3-light-grey">
    <div className="w3-row-padding">
      <div className="w3-col l4 m6">
        <img
          className="w3-image w3-round-large w3-hide-small w3-grayscale"
          src="https://www.w3schools.com/w3images/app5.jpg"
          alt="App"
          width={335}
          height={471}
        />
      </div>
      <div className="w3-col l8 m6">
        <h1 className="w3-jumbo">
          <b>Clarity</b>
        </h1>
        <h1 className="w3-xxxlarge w3-text-red">
          <b>Pixels, who?</b>
        </h1>
        <p>
          <span className="w3-xlarge">A revolution in resolution.</span> Sharp
          and clear photos with the world's best photo engine, incididunt ut
          labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
          exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
          dolore eu fugiat nulla pariatur.
        </p>
      </div>
    </div>
  </div>
    </section>
  )
}

export default Clarity